import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.json.stringify.js";
/* eslint-disable */
import axios from 'axios';
import { lang } from '@/lang';
import qs from 'qs';
import { Notification, MessageBox, Message } from 'element-ui';
import { utilCookies } from '@/util/cookies';
import storejs from 'storejs';
import { status } from 'nprogress';
// axios实例
var axiosInstance = axios.create({
  baseURL: storejs.get('base_api') || process.env.VUE_APP_BASE_API,
  timeout: 20000,
  paramsSerializer: function paramsSerializer(params) {
    return qs.stringify(params, {
      encode: true
    });
  }
});
// 错误提示
var errorNotice = function errorNotice(message) {
  return Notification.error({
    message: message,
    duration: 5000
  });
};
var errorMessage = function errorMessage(message) {
  return Message.error({
    message: message,
    duration: 3000
  });
};

// 请求拦截
axiosInstance.interceptors.request.use(function (config) {
  if (config.url) {
    return config;
  }
  throw new axios.Cancel();
}, function (error) {
  errorNotice(error.message);
  return Promise.reject(error);
});

// 响应拦截
axiosInstance.interceptors.response.use(function (response) {
  if (response.data) {
    if (response.data.code !== 1 && response.config.url !== '/auth/qr/status' && response.config.responseType !== 'blob') {
      if (response.data.code === 2003) {
        errorMessage(response.data.message);
        // code 为2003 说明该账户未注册，跳转注册页面
        var hash = window.location.hash;
        var href = window.location.href;
        window.location.href = href.replace(hash, '#/register/index');
      } else if (response.data.code === 2011) {
        // code 为2011 说明该用户为离职状态，不允许登录，直接跳转登录页面
        MessageBox.confirm(response.data.message, '', {
          confirmButtonText: lang.t('submit_btn'),
          center: true,
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false
        }).then(function () {
          utilCookies.removeToken();
          window.location.reload();
        }).catch(function () {});
      } else {
        // 登录相关接口使用Message
        if (response.config.errorMessage) {
          errorMessage(response.data.message);
        } else {
          errorNotice(response.data.message);
        }
        return Promise.reject(response.data);
      }
    }
    return response.data;
  }
}, function (error) {
  var _error$response;
  var message = '';
  var status = (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status;
  if (error.response) {
    if (status === 401) {
      message = lang.t('15c93583');
      utilCookies.removeToken();
      window.location.reload();
    } else if (status === 403) {
      message = lang.t('5c935839');
    } else if (error.response.data && error.response.data.message) {
      message = error.response.data.message;
    } else if (error.response.data && error.response.data instanceof Blob) {
      var reader = new FileReader();
      reader.addEventListener('loadend', function (e) {
        var text = e.srcElement.result;
        message = JSON.parse(text).message;
      });
      reader.readAsText(error.response.data);
    } else {
      message = "server response error code ".concat(status);
    }
  } else {
    message = error.message;
  }
  status !== 401 && errorNotice(message);
  return Promise.reject(error);
});
var timeZone = function timeZone() {
  var off = Math.abs(new Date().getTimezoneOffset() / 60);
  var end = off.toFixed(2).split('.');
  return "+".concat(end[0], ":").concat(end[1]);
};
export var baseHeaders = function baseHeaders() {
  return {
    Authorization: 'Bearer ' + utilCookies.getToken(),
    'Accept-Language': lang.i18n.locale,
    'X-Token': utilCookies.getCompanyToken(),
    'X-Timezone': timeZone()
  };
};

// 封装axiosRequest
export var axiosRequest = function axiosRequest(option) {
  var headers = baseHeaders();
  headers.Authorization = 'Bearer ' + utilCookies.getToken();
  var config = JSON.parse(JSON.stringify(option));
  config.method === undefined && (config.method = 'post');
  config.hasBaseParamsData === undefined && (config.hasBaseParamsData = true);
  // 公共请求头

  // 添加公共请求头
  config.headers = Object.assign({}, headers, config.headers);
  return axiosInstance.request(config);
};

/**
 * 第三方存储直传（如 OSS PUT）
 *
 * @description
 * 与 `axiosRequest` 的区别：
 * - 不做 JSON 序列化克隆：保留 `File` / `Blob` / `FormData` 等原始 body，
 *   也保留 `onUploadProgress` 这类函数属性
 * - 不注入业务鉴权头（Authorization / X-Token 等）：避免把业务凭证泄露给第三方域名
 * - 不走业务响应拦截器：第三方存储返回的不是 `{ code, message, data }` 结构，
 *   走业务拦截器会弹出无意义的错误提示
 * - 不设置 baseURL：目标地址为绝对 URL
 * - 超时放宽：大文件上传耗时较长
 *
 * @param {Object} option - axios 请求配置（url / method / data / headers / onUploadProgress 等）
 * @returns {Promise<Object>} axios 响应
 */
export var ossRequest = function ossRequest(option) {
  // 浅拷贝即可：保留 File 实例与函数属性
  var config = _objectSpread({}, option);
  config.method = (config.method || 'put').toLowerCase();

  // 默认实例 timeout 为 0（不超时），这里显式设置截止时间，避免请求悬挂
  if (!config.timeout) {
    config.timeout = 5 * 60 * 1000; // 5 分钟
  }

  return axios.request(config);
};